import { defineMessages } from 'react-intl'

const messages = {
  questionAboutQuantityProductToDeliver: {
    id: 'app.components.product-quantity-selector.question',
    defaultMessage: 'How many can you deliver?',
  },
  productQuantity: {
    id: 'app.components.product-quantity-selector.product-quantity',
    defaultMessage: 'Product quantity',
  },
  decreaseButton: {
    id: 'app.components.product-quantity-selector.increase',
    defaultMessage: 'Increase product quantity',
  },
  increaseButton: {
    id: 'app.components.product-quantity-selector.decrease',
    defaultMessage: 'Decrease product quantity',
  },
}

export default defineMessages(messages)
